<template>
    <div class="contentList" :class="{'contentClass':isPopup }">
        <div class="search">
            <div v-if="!isPopup" class="searchTitle">Services</div>
            <van-search
                @search="handleSearch"
                @keypress.enter="handleSearch"
                :class="['searchInput', { popupClass:isPopup  }]"
                v-model="queryForm.search"
                placeholder="search for service"
                show-action
            >
                <template #action>
                    <div @click="handleSearch">Search</div>
                </template>
            </van-search>
        </div>
        <!-- <van-divider /> -->
        <van-collapse v-model="activeNames" >
            <van-collapse-item :name="index" v-for="(item,index) in displayData" :key="index" >
                <template #title>
                    <div class="servicesTitle">
                        <div>{{ index }}</div>
                        <div class="servicesNum">{{ item.length }} services</div>
                    </div>
                </template>
                <HomeCard :list="item" :shopkey="index" :isPopup="isPopup"/>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
import HomeCard from '@/components/Home/HomeCard.vue'
export default {
    name:'Service',
    props:{
        isPopup:{
            type:Boolean,
            default:false,
        },
        data:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        shop_supplier_id:{
            type: [String, Number],
            default:''
        }
    },
    data(){
        return {
            queryForm:{
                search:'',
                sort:'',
                page:1,
                list_rows:20
            },
            activeNames: ['Massage'],
            serviceData: null
        }
    },
    computed:{
        displayData(){
            return this.serviceData !== null ? this.serviceData : this.data
        }
    },
    watch:{
        data:{
            handler(newVal){
                if(newVal && Object.keys(newVal).length > 0){
                    this.activeNames = Object.keys(newVal)
                }
            },
            immediate: true
        }
    },
    mounted(){
    },
    components:{
        HomeCard
    },
    methods:{
        handleSearch(){
            const params = {
                search: this.queryForm.search,
                sort: this.queryForm.sort,
                page: this.queryForm.page,
                list_rows: this.queryForm.list_rows,
                shop_supplier_id: this.shop_supplier_id
            }
            this.$api.getSupplierList(params).then(res => {
                if(res.code == 1 && res.data && res.data.list && res.data.list.data){
                    // 获取第一个店铺的Services列表
                    const supplier = res.data.list.data[0]
                    if(supplier && supplier.showservice){
                        // 将Services按分类分组（与原始data结构保持一致）
                        const grouped = {}
                        supplier.showservice.forEach(service => {
                            // 使用服务名的前缀作为分类，或者直接用 "搜索结果"
                            const categoryName = 'Search Results'
                            if(!grouped[categoryName]){
                                grouped[categoryName] = []
                            }
                            grouped[categoryName].push(service)
                        })
                        this.serviceData = grouped
                        this.activeNames = Object.keys(grouped)
                    } else {
                        this.serviceData = {}
                        this.activeNames = []
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
     ::v-deep .van-cell{
        padding: 10px 0;
    }
    ::v-deep .van-collapse-item__content{
        padding: 12px 0;
    }
    .contentList{
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        .search{
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
    .servicesTitle{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 0.5rem;
        font-size: 1rem;
        font-weight: 600;
        color: #1a1a1a;
        .servicesNum{
            width: auto;
            height: 1.5rem;
            border-radius: 1.625rem;
            background: #EEEEEE;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .75rem;
            padding: 0 .75rem;
        }
    }
    }
    .popupClass{
        width: 100%;
        padding: 1rem 0;
    }
    .contentClass{
        padding: 0;
    }
    .searchInput{
        flex: 1;
    }
    .searchTitle{
        flex-shrink: 0;
    }
</style>
